import { Currency } from "../../../tables/types/types"
import { Measure, Discount } from "../../common"

export enum ProductType {
    UNITARY = 'Unitary',
    PACKAGE = 'Package',
    BULK = 'Bulk'
}

export enum MeasureLabel {
    BAG = 'Bag',
    BIG_BAG = 'BigBag',
    BOTTLE = 'Bottle',
    BOX = 'Box',
    BUCKET = 'Bucket',
    CAN = 'Can',
    DOYPACK = 'Doypack',
    DRAWER = 'Drawer',
    DRUM = 'Drum',
    MESH = 'Mesh',
    PALLET = 'Pallet',
    SACHET = 'Sachet',
    UNITS = 'Units',
}

export type Product = {
    companyId: string
    id: string
    code: number
    supplierCode: string
    name: string
    categoryId: string
    supplierId: string
    imageUrl?: string
    description?: string
    type: ProductType
    units?: number
    unitTypeId: string
    secondaryUnits?: number
    secondaryUnitTypeId?: string
    measures: Measure[]
    unitMeasures?: Measure[]
    measureLabel?: MeasureLabel
    loted: boolean
    // Permite vender sin stock disponible (con advertencia). Solo aplica a productos sin partidas.
    allowNegativeStock?: boolean
    equivalences?: Equivalence[]
    archived?: boolean
    negativeStateUserId?: string
    negativeStateAt?: string
}

export type Category = {
    companyId: string
    id: string
    name: string
    imageUrl?: string
    archived?: boolean
    negativeStateUserId?: string
    negativeStateAt?: string
}

export type ProductPrices = {
    companyId: string
    id: string
    productId: string
    purchasePrice: number
    vatTaxId: string
    saleYield?: number
    bonuses: Discount[]
    currency: Currency
}

export enum LotAttribute {
    TONE = 'Tone',
    CALIBER = 'Caliber',
    DUE_DATE = 'DueDate'
}

export type LotAttributes = {
    [key in LotAttribute]?: string
}

export type Lot = {
    companyId: string
    id: string
    code: string
    productId: string
    attributes?: LotAttributes
}

export type PurchasePricesData = {
    [key: string]: number
}

export type Equivalence = {
    productId: string,
    equivalence: number
}
